var _font;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTrafficSignSpeedLimitEu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Speed_x5F_Limit_x5F_EU_x0A_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _font || (_font = /*#__PURE__*/React.createElement("font", {
    horizAdvX: 1000
  }, /*#__PURE__*/React.createElement("fontFace", {
    fontFamily: "DINEngschriftStd",
    unitsPerEm: 1000,
    underlinePosition: -100,
    underlineThickness: 50
  }), /*#__PURE__*/React.createElement("missingGlyph", {
    horizAdvX: 500,
    d: "M0,0l500,0l0,700l-500,0M250,395l-170,255l340,0M280,350l170,255l0,-510M80,50l170,255l170,-255M50,605l170,-255l-170,-255z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "A",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC6",
    horizAdvX: 611,
    d: "M2,0l108,0l39,153l140,0l0,-153l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0l0,96l-389,0M289,249l-116,0l92,367l24,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC1",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0M139,744l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC2",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0M59,744l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC4",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0M78,756l90,0l0,102l-90,0M240,756l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC0",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0M179,885l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC5",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0M102,835C102,780 148,733 204,733C260,733 306,779 306,835C306,890 260,937 204,937C148,937 102,891 102,835M143,835C143,869 170,896 204,896C238,896 265,869 265,835C265,801 238,774 204,774C170,774 143,801 143,835z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC3",
    horizAdvX: 407,
    d: "M254,249l-102,0l50,258l2,0M2,0l102,0l30,153l139,0l30,-153l102,0l-159,712l-85,0M323,869C322,843 307,824 279,824C257,824 166,864 135,864C71,864 46,814 34,753l51,0C86,779 101,798 129,798C152,798 242,758 273,758C337,758 362,808 374,869z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "B",
    horizAdvX: 426,
    d: "M48,0l139,0C319,0 378,70 378,194l0,40C378,308 356,351 308,374C353,402 378,430 378,506l0,26C378,625 329,712 197,712l-149,0M150,330l45,0C269,330 282,293 282,222C282,152 276,102 194,102l-44,0M150,616l42,0C259,616 282,583 282,520C282,455 264,420 196,420l-46,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "C",
    horizAdvX: 407,
    d: "M372,203l-102,0l0,-35C270,112 234,96 206,96C160,96 144,128 144,169l0,364C144,581 156,616 207,616C246,616 270,582 270,542l0,-34l102,0l0,40C372,647 302,718 208,718C109,718 42,647 42,554l0,-392C42,32 132,-6 210,-6C301,-6 372,71 372,159z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC7",
    horizAdvX: 407,
    d: "M131,-86l17,-20C161,-101 173,-99 187,-99C210,-99 232,-114 232,-137C232,-171 200,-178 178,-178C156,-178 134,-171 113,-163l-17,-42C115,-212 150,-224 189,-224C244,-224 312,-198 312,-133C312,-101 293,-58 227,-58C217,-58 206,-59 196,-60l43,56C316,11 372,81 372,159l0,44l-102,0l0,-35C270,112 234,96 206,96C160,96 144,128 144,169l0,364C144,581 156,616 207,616C246,616 270,582 270,542l0,-34l102,0l0,40C372,647 302,718 208,718C109,718 42,647 42,554l0,-392C42,42 119,0 192,-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "D",
    horizAdvX: 426,
    d: "M48,0l142,0C310,0 378,63 378,195l0,333C378,643 314,712 199,712l-151,0M150,616l47,0C257,616 276,584 276,528l0,-343C276,124 254,96 197,96l-47,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2206",
    horizAdvX: 451,
    d: "M22,0l406,0l0,67l-143,645l-111,0l-152,-648M117,86l72,307C200,454 220,519 226,563l1,0C234,517 255,441 265,382l67,-296z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "E",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0l0,96l-304,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC9",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0l0,96l-304,0M130,744l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCA",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0l0,96l-304,0M50,744l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCB",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0l0,96l-304,0M69,756l90,0l0,102l-90,0M231,756l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xC8",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0l0,96l-304,0M170,885l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD0",
    horizAdvX: 426,
    d: "M150,616l47,0C257,616 276,584 276,528l0,-343C276,124 254,96 197,96l-47,0l0,254l70,0l0,66l-70,0M48,0l142,0C310,0 378,63 378,195l0,333C378,643 314,712 199,712l-151,0l0,-296l-48,0l0,-66l48,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u20AC",
    horizAdvX: 372,
    d: "M341,694C328,704 295,717 247,717C146,717 87,637 74,469l-38,0l-20,-78l52,0C67,379 67,367 67,358C67,346 67,333 68,324l-32,0l-20,-79l60,0C91,65 150,-5 246,-5C298,-5 328,4 341,14l0,97C326,96 305,87 265,87C212,87 180,132 174,245l86,0l20,79l-111,0l0,34l0,33l128,0l20,78l-143,0C180,575 209,624 265,624C305,624 327,613 341,599z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "F",
    horizAdvX: 370,
    d: "M48,0l102,0l0,304l176,0l0,96l-176,0l0,216l202,0l0,96l-304,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "G",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,224l-183,0l0,-90l81,0l0,-134C282,119 250,96 213,96C176,96 144,119 144,168l0,376C144,593 176,616 213,616C250,616 282,593 282,544l0,-36l102,0l0,36C384,660 296,718 213,718C130,718 42,660 42,544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "H",
    horizAdvX: 426,
    d: "M48,0l102,0l0,317l126,0l0,-317l102,0l0,712l-102,0l0,-305l-126,0l0,305l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "I",
    horizAdvX: 204,
    d: "M51,0l102,0l0,712l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCD",
    horizAdvX: 204,
    d: "M51,0l102,0l0,712l-102,0M37,744l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCE",
    horizAdvX: 204,
    d: "M51,0l102,0l0,712l-102,0M-43,744l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCF",
    horizAdvX: 204,
    d: "M51,0l102,0l0,712l-102,0M-24,756l90,0l0,102l-90,0M138,756l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xCC",
    horizAdvX: 204,
    d: "M51,0l102,0l0,712l-102,0M77,885l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "J",
    horizAdvX: 333,
    d: "M285,712l-102,0l0,-530C183,111 139,96 114,96C93,96 72,108 58,122l-80,-64C3,30 46,-6 111,-6C220,-6 285,74 285,168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "K",
    horizAdvX: 426,
    d: "M48,0l102,0l0,213l55,103l116,-316l108,0l-165,427l139,285l-102,0l-149,-325l-2,0l0,325l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "L",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,610l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0141",
    horizAdvX: 370,
    d: "M48,0l304,0l0,102l-202,0l0,243l120,96l0,90l-120,-96l0,277l-102,0l0,-357l-48,-38l0,-90l48,38z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "M",
    horizAdvX: 556,
    d: "M48,0l102,0l0,433l2,0l100,-306l51,0l101,306l2,0l0,-433l102,0l0,712l-99,0l-130,-377l-2,0l-131,377l-98,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "N",
    horizAdvX: 444,
    d: "M44,0l102,0l0,428l2,0l156,-428l96,0l0,712l-102,0l0,-429l-2,0l-154,429l-98,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD1",
    horizAdvX: 444,
    d: "M44,0l102,0l0,428l2,0l156,-428l96,0l0,712l-102,0l0,-429l-2,0l-154,429l-98,0M341,869C340,843 325,824 297,824C275,824 184,864 153,864C89,864 64,814 52,753l51,0C104,779 119,798 147,798C170,798 260,758 291,758C355,758 380,808 392,869z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "O",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376C282,119 250,96 213,96C176,96 144,119 144,168z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0152",
    horizAdvX: 610,
    d: "M288,158C288,118 261,84 219,84C177,84 150,118 150,158l0,396C150,594 177,628 219,628C261,628 288,594 288,554M592,712l-304,0l0,-36l-2,0C272,698 245,718 201,718C104,718 48,639 48,549l0,-386C48,73 104,-6 201,-6C234,-6 269,11 286,34l2,0l0,-34l304,0l0,102l-202,0l0,209l176,0l0,96l-176,0l0,209l202,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD3",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376C282,119 250,96 213,96C176,96 144,119 144,168M148,744l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD4",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376C282,119 250,96 213,96C176,96 144,119 144,168M68,744l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD6",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376C282,119 250,96 213,96C176,96 144,119 144,168M87,756l90,0l0,102l-90,0M249,756l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD2",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376C282,119 250,96 213,96C176,96 144,119 144,168M188,885l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2126",
    horizAdvX: 455,
    d: "M110,89l-88,0l0,-89l172,0l0,63C163,105 130,223 130,368C130,512 164,614 228,614C296,614 321,494 321,371C321,214 290,106 257,63l0,-63l172,0l0,89l-88,0l0,3C380,155 419,271 419,399C419,547 361,709 231,709C111,709 33,572 33,389C33,265 69,160 110,92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD8",
    horizAdvX: 426,
    d: "M10,-16l38,-22l40,84C120,11 167,-6 213,-6C296,-6 384,52 384,168l0,376C384,576 377,604 366,625l50,103l-38,22l-40,-84C304,701 258,718 213,718C130,718 42,660 42,544l0,-376C42,137 48,110 60,87M146,262l-2,0l0,282C144,593 176,616 213,616C248,616 279,595 282,549M280,449l2,0l0,-281C282,119 250,96 213,96C177,96 146,118 144,163z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD5",
    horizAdvX: 426,
    d: "M42,168C42,52 130,-6 213,-6C296,-6 384,52 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376C282,119 250,96 213,96C176,96 144,119 144,168M332,869C331,843 316,824 288,824C266,824 175,864 144,864C80,864 55,814 43,753l51,0C95,779 110,798 138,798C161,798 251,758 282,758C346,758 371,808 383,869z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "P",
    horizAdvX: 407,
    d: "M48,0l102,0l0,278l52,0C277,278 322,306 350,352C374,391 379,433 379,495C379,580 368,625 333,662C298,699 257,712 201,712l-153,0M150,616l53,0C283,616 283,561 283,494C283,423 282,374 199,374l-49,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Q",
    horizAdvX: 426,
    d: "M144,544C144,593 176,616 213,616C250,616 282,593 282,544l0,-376l0,-2l-41,33l-52,-62l46,-37C228,97 221,96 213,96C176,96 144,119 144,168M42,168C42,52 130,-6 213,-6C251,-6 289,6 320,31l60,-49l52,62l-63,51C379,116 384,140 384,168l0,376C384,660 296,718 213,718C130,718 42,660 42,544z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "R",
    horizAdvX: 426,
    d: "M150,616l53,0C278,616 290,577 290,505C290,434 279,394 208,394l-58,0M48,0l102,0l0,304l61,0l95,-304l108,0l-110,325C369,361 392,421 392,503C392,641 333,712 212,712l-164,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "S",
    horizAdvX: 406,
    d: "M378,557C378,636 310,718 208,718C91,718 33,631 33,523C33,434 56,376 144,340l73,-30C267,290 276,278 276,202C276,137 271,96 202,96C150,96 130,132 130,169l0,32l-102,0l0,-38C28,67 103,-6 202,-6C334,-6 378,83 378,203C378,307 361,364 271,398l-78,31C140,450 135,469 135,524C135,571 148,616 204,616C256,616 276,577 276,530l0,-23l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0160",
    horizAdvX: 406,
    d: "M378,557C378,636 310,718 208,718C91,718 33,631 33,523C33,434 56,376 144,340l73,-30C267,290 276,278 276,202C276,137 271,96 202,96C150,96 130,132 130,169l0,32l-102,0l0,-38C28,67 103,-6 202,-6C334,-6 378,83 378,203C378,307 361,364 271,398l-78,31C140,450 135,469 135,524C135,571 148,616 204,616C256,616 276,577 276,530l0,-23l102,0M348,885l-78,0l-67,-95l-67,95l-78,0l98,-141l94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "T",
    horizAdvX: 332,
    d: "M115,0l102,0l0,616l118,0l0,96l-338,0l0,-96l118,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDE",
    horizAdvX: 407,
    d: "M48,0l102,0l0,154l52,0C277,154 322,182 350,228C374,267 379,309 379,371C379,456 368,501 333,538C298,575 257,588 201,588l-51,0l0,124l-102,0M150,492l53,0C283,492 283,437 283,370C283,299 282,250 199,250l-49,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "U",
    horizAdvX: 426,
    d: "M378,712l-102,0l0,-542C276,120 249,96 213,96C177,96 150,120 150,170l0,542l-102,0l0,-552C48,67 122,-6 213,-6C304,-6 378,67 378,160z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDA",
    horizAdvX: 426,
    d: "M378,712l-102,0l0,-542C276,120 249,96 213,96C177,96 150,120 150,170l0,542l-102,0l0,-552C48,67 122,-6 213,-6C304,-6 378,67 378,160M148,744l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDB",
    horizAdvX: 426,
    d: "M378,712l-102,0l0,-542C276,120 249,96 213,96C177,96 150,120 150,170l0,542l-102,0l0,-552C48,67 122,-6 213,-6C304,-6 378,67 378,160M68,744l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDC",
    horizAdvX: 426,
    d: "M378,712l-102,0l0,-542C276,120 249,96 213,96C177,96 150,120 150,170l0,542l-102,0l0,-552C48,67 122,-6 213,-6C304,-6 378,67 378,160M87,756l90,0l0,102l-90,0M249,756l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD9",
    horizAdvX: 426,
    d: "M378,712l-102,0l0,-542C276,120 249,96 213,96C177,96 150,120 150,170l0,542l-102,0l0,-552C48,67 122,-6 213,-6C304,-6 378,67 378,160M188,885l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "V",
    horizAdvX: 407,
    d: "M394,712l-108,0l-82,-497l-2,0l-81,497l-108,0l145,-712l90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "W",
    horizAdvX: 593,
    d: "M577,712l-108,0l-49,-463l-2,0l-83,463l-78,0l-80,-452l-2,0l-51,452l-108,0l106,-712l96,0l77,462l2,0l78,-462l96,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "X",
    horizAdvX: 389,
    d: "M-2,0l108,0l88,240l89,-240l108,0l-147,373l136,339l-108,0l-78,-211l-77,211l-108,0l133,-339z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Y",
    horizAdvX: 388,
    d: "M143,0l102,0l0,301l140,411l-108,0l-82,-283l-2,0l-82,283l-108,0l140,-411z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDD",
    horizAdvX: 388,
    d: "M143,0l102,0l0,301l140,411l-108,0l-82,-283l-2,0l-82,283l-108,0l140,-411M129,744l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0178",
    horizAdvX: 388,
    d: "M143,0l102,0l0,301l140,411l-108,0l-82,-283l-2,0l-82,283l-108,0l140,-411M68,756l90,0l0,102l-90,0M230,756l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "Z",
    horizAdvX: 333,
    d: "M15,0l303,0l0,96l-196,0l196,535l0,81l-293,0l0,-96l182,0l-192,-526z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017D",
    horizAdvX: 333,
    d: "M15,0l303,0l0,96l-196,0l196,535l0,81l-293,0l0,-96l182,0l-192,-526M312,885l-78,0l-67,-95l-67,95l-78,0l98,-141l94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "a",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE1",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218M120,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE2",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218M40,574l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB4",
    horizAdvX: 186,
    d: "M28,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE4",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218M59,586l90,0l0,102l-90,0M221,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE6",
    horizAdvX: 572,
    d: "M337,353C337,391 356,411 387,411C418,411 437,391 437,353l0,-58l-100,0M539,355C539,444 481,513 387,513C348,513 310,499 285,477C258,500 226,513 184,513C92,513 33,450 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C185,-6 230,18 254,66C274,27 320,-7 387,-6C476,-5 539,59 539,147l-102,0C435,125 426,96 387,96C356,96 337,114 337,146l0,69l202,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2113",
    horizAdvX: 358,
    d: "M311,155C291,118 265,79 230,79C192,79 170,116 170,211l0,60C249,379 300,496 300,608C300,709 270,774 208,774C138,774 77,703 77,541l0,-265C59,251 40,231 16,206l22,-56C51,163 65,178 77,190l0,-15C76,80 107,-2 210,-2C266,-2 315,32 348,114M170,521C170,655 190,694 212,694C239,694 249,670 249,617C249,542 217,452 170,374z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE0",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218M160,715l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "&",
    horizAdvX: 481,
    d: "M353,0l102,0l-77,122l76,98l-63,44l-55,-75C301,239 267,299 242,338C298,388 346,451 346,517C346,587 298,646 211,646C119,646 72,584 72,508C72,448 98,395 134,344C78,294 36,237 36,159C36,60 102,-6 183,-6C237,-6 279,14 319,54M126,164C126,208 150,242 180,273l98,-156C263,98 233,74 202,74C158,74 126,115 126,164M162,506C162,537 182,566 213,566C243,566 262,540 262,515C262,465 226,427 201,403C179,439 162,475 162,506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2248",
    horizAdvX: 401,
    d: "M335,423C318,388 303,361 275,361C256,361 238,375 214,391C197,401 172,422 134,422C86,422 48,383 28,331l37,-29C81,333 96,364 128,364C150,364 166,352 191,334C224,311 244,302 271,302C317,302 354,344 372,394M335,271C318,236 303,208 275,208C256,208 239,223 214,239C197,249 172,269 134,269C86,269 48,231 28,178l37,-28C80,180 96,212 128,212C151,212 166,200 191,182C224,159 244,150 271,150C317,150 354,192 372,242z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE5",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218M83,660C83,605 129,558 185,558C241,558 287,604 287,660C287,715 241,762 185,762C129,762 83,716 83,660M124,660C124,694 151,721 185,721C219,721 246,694 246,660C246,626 219,599 185,599C151,599 124,626 124,660z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "^",
    horizAdvX: 600,
    d: "M50,283l80,0l170,339l170,-339l80,0l-217,429l-66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "~",
    horizAdvX: 600,
    d: "M495,330C472,295 447,258 407,258C380,258 342,278 305,294C267,312 228,327 194,327C127,327 91,282 69,240l36,-64C128,210 153,247 193,247C220,247 258,227 295,211C333,193 372,178 406,178C473,178 509,223 531,265z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "*",
    horizAdvX: 370,
    d: "M31,604l100,-56l-100,-55l28,-53l98,60l-4,-116l64,0l-4,116l98,-60l28,53l-100,55l100,56l-28,52l-98,-60l4,116l-64,0l4,-116l-98,60z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "@",
    horizAdvX: 800,
    d: "M513,410C513,330 444,211 368,211C318,211 285,242 285,298C285,382 352,493 439,493C487,493 513,457 513,410M639,548l-63,0l-20,-61l-2,0C534,541 486,565 439,565C299,565 205,423 205,291C205,208 262,139 348,139C410,139 441,171 470,202l2,0C477,160 505,139 550,139C635,139 778,252 778,419C778,594 620,718 432,718C226,718 54,558 54,358C54,149 221,-6 430,-6C566,-6 693,58 758,165l-77,0C634,108 535,60 438,60C265,60 131,190 131,353C131,509 265,652 433,652C575,652 701,554 701,414C701,318 629,199 565,199C548,199 542,211 542,228C542,237 546,255 552,273z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE3",
    horizAdvX: 370,
    d: "M235,0l102,0l0,353C337,459 269,513 184,513C138,513 100,497 73,470C46,443 30,405 27,360l99,0C132,393 158,411 184,411C222,411 235,385 235,351l0,-53C214,299 200,301 186,301C58,301 25,245 25,129C25,17 88,-6 135,-6C184,-6 206,15 233,52l2,0M235,149C235,108 214,84 180,84C147,84 127,110 127,149C127,203 163,221 207,221C216,221 224,220 235,218M304,699C303,673 288,654 260,654C238,654 147,694 116,694C52,694 27,644 15,583l51,0C67,609 82,628 110,628C133,628 223,588 254,588C318,588 343,638 355,699z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "b",
    horizAdvX: 389,
    d: "M42,0l102,0l0,46C170,17 190,-6 241,-6C282,-6 312,9 330,42C342,64 347,95 347,151l0,193C347,417 344,446 331,467C314,494 289,513 240,513C200,513 168,494 146,461l-2,0l0,251l-102,0M245,165C245,124 230,96 195,96C164,96 144,122 144,159l0,197C144,388 166,411 195,411C234,411 245,383 245,351z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\\\\\\\\",
    horizAdvX: 222,
    d: "M85,718l-80,0l132,-724l80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "|",
    horizAdvX: 222,
    d: "M71,-250l80,0l0,1000l-80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "{",
    horizAdvX: 222,
    d: "M3,277C40,277 67,229 67,162l0,-151C67,-59 112,-100 165,-100l54,0l0,60l-18,0C169,-40 157,-15 157,27l0,149C157,268 116,300 88,305l0,2C116,312 157,347 157,435l0,151C157,627 169,652 201,652l18,0l0,60l-54,0C112,712 67,671 67,601l0,-152C67,384 40,337 3,337z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "}",
    horizAdvX: 222,
    d: "M219,337C182,337 155,384 155,449l0,152C155,671 110,712 57,712l-54,0l0,-60l18,0C53,652 65,627 65,586l0,-151C65,347 106,312 134,307l0,-2C106,300 65,268 65,176l0,-149C65,-15 53,-40 21,-40l-18,0l0,-60l54,0C110,-100 155,-59 155,11l0,151C155,229 182,277 219,277z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "[",
    horizAdvX: 222,
    d: "M214,712l-156,0l0,-812l156,0l0,60l-66,0l0,692l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "]",
    horizAdvX: 222,
    d: "M8,-100l156,0l0,812l-156,0l0,-60l66,0l0,-692l-66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02D8",
    horizAdvX: 186,
    d: "M196,715C191,678 168,639 93,639C18,639 -5,678 -10,715l-51,0C-47,626 5,579 93,579C181,579 233,626 247,715z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA6",
    horizAdvX: 222,
    d: "M71,-175l80,0l0,350l-80,0M71,325l80,0l0,350l-80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2022",
    horizAdvX: 500,
    d: "M72,356C72,258 152,178 250,178C348,178 428,258 428,356C428,454 348,534 250,534C152,534 72,454 72,356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "c",
    horizAdvX: 370,
    d: "M150,353C150,391 169,411 200,411C231,411 250,392 250,351l102,0C352,445 294,513 200,513C138,513 91,484 67,440C53,414 48,378 48,337l0,-167C48,129 53,93 67,67C91,23 138,-6 200,-6C247,-6 284,11 311,39C337,66 352,105 352,147l-102,0C248,125 239,96 200,96C169,96 150,114 150,146z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C7",
    horizAdvX: 186,
    d: "M238,715l-78,0l-67,-95l-67,95l-78,0l98,-141l94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE7",
    horizAdvX: 370,
    d: "M112,-86l17,-20C142,-101 154,-99 168,-99C191,-99 213,-114 213,-137C213,-171 181,-178 159,-178C137,-178 115,-171 94,-163l-17,-42C96,-212 131,-224 170,-224C225,-224 293,-198 293,-133C293,-101 274,-58 208,-58C198,-58 187,-59 177,-60l43,56C258,0 288,15 311,39C337,66 352,105 352,147l-102,0C248,125 239,96 200,96C169,96 150,114 150,146l0,207C150,391 169,411 200,411C231,411 250,392 250,351l102,0C352,445 294,513 200,513C138,513 91,484 67,440C53,414 48,378 48,337l0,-167C48,129 53,93 67,67C87,30 125,3 175,-4z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB8",
    horizAdvX: 186,
    d: "M20,-86l17,-20C50,-101 62,-99 76,-99C99,-99 121,-114 121,-137C121,-171 89,-178 67,-178C45,-178 23,-171 2,-163l-17,-42C4,-212 39,-224 78,-224C133,-224 201,-198 201,-133C201,-101 182,-58 116,-58C106,-58 95,-59 85,-60l46,60l-46,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA2",
    horizAdvX: 372,
    d: "M164,96C147,102 136,118 136,142l0,215C136,372 139,383 144,392C149,401 156,408 164,411M164,-90l41,0l0,84C243,-3 274,13 297,37C323,64 338,103 338,147l-102,0C234,126 228,104 205,96l0,315C225,404 236,386 236,351l102,0C338,441 287,506 205,513l0,75l-41,0l0,-75C113,508 74,481 53,442C39,416 34,380 34,339l0,-172C34,126 39,90 53,64C74,26 113,-2 164,-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C6",
    horizAdvX: 186,
    d: "M-52,574l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ":",
    horizAdvX: 186,
    d: "M42,0l102,0l0,102l-102,0M42,227l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ",",
    horizAdvX: 186,
    d: "M42,-74l102,74l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA9",
    horizAdvX: 800,
    d: "M524,287C515,237 470,197 413,197C327,197 271,275 271,358C271,445 322,516 411,516C468,516 513,478 524,431l66,0C577,528 501,582 410,582C278,582 199,486 199,356C199,230 283,131 413,131C501,131 572,193 590,287M690,356C690,193 560,60 400,60C240,60 110,193 110,356C110,519 240,652 400,652C560,652 690,519 690,356M38,356C38,156 200,-6 400,-6C600,-6 762,156 762,356C762,556 600,718 400,718C200,718 38,556 38,356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA4",
    horizAdvX: 372,
    d: "M4,214l41,-40l41,42C109,195 146,181 186,181C226,181 263,194 286,215l41,-41l41,41l-41,41C347,278 361,315 361,356C361,396 348,433 327,457l41,41l-40,41l-41,-42C263,518 226,531 186,531C146,531 109,517 86,497l-41,42l-41,-41l41,-42C24,433 11,396 11,356C11,316 25,278 46,256M77,356C77,416 126,465 186,465C246,465 295,416 295,356C295,296 246,247 186,247C126,247 77,296 77,356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "d",
    horizAdvX: 389,
    d: "M144,351C144,383 155,411 194,411C223,411 245,388 245,356l0,-197C245,122 225,96 194,96C159,96 144,124 144,165M245,0l102,0l0,712l-102,0l0,-251l-2,0C221,494 189,513 149,513C100,513 75,494 58,467C45,446 42,417 42,344l0,-193C42,95 47,64 59,42C77,9 107,-6 148,-6C199,-6 219,17 245,46z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2020",
    horizAdvX: 370,
    d: "M140,-205l90,0l0,601l134,0l0,90l-134,0l0,226l-90,0l0,-226l-134,0l0,-90l134,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2021",
    horizAdvX: 370,
    d: "M140,494l-134,0l0,-80l134,0l0,-321l-134,0l0,-80l134,0l0,-218l90,0l0,218l134,0l0,80l-134,0l0,321l134,0l0,80l-134,0l0,218l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB0",
    horizAdvX: 260,
    d: "M69,606C69,640 96,667 130,667C164,667 191,640 191,606C191,572 164,545 130,545C96,545 69,572 69,606M18,606C18,544 68,494 130,494C192,494 242,544 242,606C242,668 192,718 130,718C68,718 18,668 18,606z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA8",
    horizAdvX: 186,
    d: "M-33,586l90,0l0,102l-90,0M129,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF7",
    horizAdvX: 600,
    d: "M47,213l506,0l0,80l-506,0M236,46C236,11 265,-18 300,-18C335,-18 364,11 364,46C364,81 335,110 300,110C265,110 236,81 236,46M236,460C236,425 265,396 300,396C335,396 364,425 364,460C364,495 335,524 300,524C265,524 236,495 236,460z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "$",
    horizAdvX: 372,
    d: "M161,437C122,455 118,476 118,524C118,566 127,603 161,616M212,304C252,287 259,270 259,202C259,144 255,106 212,96M161,-90l51,0l0,84C323,5 361,89 361,203C361,307 344,364 254,398l-42,17l0,201C246,605 259,572 259,530l0,-23l102,0l0,50C361,632 303,707 212,718l0,75l-51,0l0,-75C64,705 16,624 16,523C16,434 39,376 127,340l34,-14l0,-230C127,104 113,134 113,165l0,36l-102,0l0,-40C11,73 74,4 161,-6z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02D9",
    horizAdvX: 186,
    d: "M48,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0131",
    horizAdvX: 186,
    d: "M42,0l102,0l0,507l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "e",
    horizAdvX: 370,
    d: "M337,215l0,140C337,444 279,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337l0,-167C33,129 38,93 52,67C76,23 123,-6 185,-6C232,-6 269,11 296,39C322,66 337,105 337,147l-102,0C233,125 224,96 185,96C154,96 135,114 135,146l0,69M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-58l-100,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE9",
    horizAdvX: 370,
    d: "M337,215l0,140C337,444 279,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337l0,-167C33,129 38,93 52,67C76,23 123,-6 185,-6C232,-6 269,11 296,39C322,66 337,105 337,147l-102,0C233,125 224,96 185,96C154,96 135,114 135,146l0,69M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-58l-100,0M120,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEA",
    horizAdvX: 370,
    d: "M337,215l0,140C337,444 279,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337l0,-167C33,129 38,93 52,67C76,23 123,-6 185,-6C232,-6 269,11 296,39C322,66 337,105 337,147l-102,0C233,125 224,96 185,96C154,96 135,114 135,146l0,69M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-58l-100,0M40,574l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEB",
    horizAdvX: 370,
    d: "M337,215l0,140C337,444 279,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337l0,-167C33,129 38,93 52,67C76,23 123,-6 185,-6C232,-6 269,11 296,39C322,66 337,105 337,147l-102,0C233,125 224,96 185,96C154,96 135,114 135,146l0,69M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-58l-100,0M59,586l90,0l0,102l-90,0M221,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xE8",
    horizAdvX: 370,
    d: "M337,215l0,140C337,444 279,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337l0,-167C33,129 38,93 52,67C76,23 123,-6 185,-6C232,-6 269,11 296,39C322,66 337,105 337,147l-102,0C233,125 224,96 185,96C154,96 135,114 135,146l0,69M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-58l-100,0M160,715l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 8,
    horizAdvX: 372,
    d: "M236,462C236,434 212,412 186,412C160,412 136,434 136,462l0,104C136,594 160,616 186,616C212,616 236,594 236,566M34,526C34,442 36,413 85,374C36,337 34,307 34,199C34,112 41,88 62,57C85,22 127,-6 186,-6C245,-6 287,22 310,57C331,88 338,112 338,199C338,307 336,337 287,374C336,413 338,442 338,526C338,604 328,629 301,663C274,698 232,718 186,718C140,718 98,698 71,663C44,629 34,604 34,526M236,146C236,118 212,96 186,96C160,96 136,118 136,146l0,140C136,314 160,336 186,336C212,336 236,314 236,286z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2026",
    horizAdvX: 1000,
    d: "M116,0l102,0l0,102l-102,0M449,0l102,0l0,102l-102,0M782,0l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2014",
    horizAdvX: 1000,
    d: "M0,229l1000,0l0,96l-1000,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2013",
    horizAdvX: 500,
    d: "M0,229l500,0l0,96l-500,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "=",
    horizAdvX: 600,
    d: "M47,313l506,0l0,80l-506,0M47,113l506,0l0,80l-506,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u212E",
    horizAdvX: 873,
    d: "M838,346l0,9C838,556 658,718 435,718C214,718 34,556 34,355C34,156 214,-5 435,-5C565,-5 682,50 753,135l-57,0C632,62 540,15 436,15C340,15 253,57 190,122C185,128 182,136 182,145l0,197C182,345 184,346 187,346M690,372C690,369 689,365 686,365l-499,0C184,365 182,369 182,372l0,193C182,575 185,584 191,590C254,654 341,696 436,696C532,696 617,655 681,593C687,587 690,578 690,570z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF0",
    horizAdvX: 370,
    d: "M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154M86,608l28,-40l74,35C210,575 224,538 235,492l-2,-2C223,503 204,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337l0,-167C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,238C337,486 324,577 274,643l63,29l-28,40l-68,-32C219,700 193,716 161,727l-83,-44C109,671 135,657 155,640z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "!",
    horizAdvX: 240,
    d: "M95,176l50,0l39,536l-128,0M69,0l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA1",
    horizAdvX: 240,
    d: "M56,-205l128,0l-39,536l-50,0M69,405l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "f",
    horizAdvX: 222,
    d: "M55,0l102,0l0,427l76,0l0,80l-76,0l0,74C157,603 168,616 187,616l46,0l0,96l-47,0C120,712 55,674 55,576l0,-69l-50,0l0,-80l50,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB01",
    horizAdvX: 407,
    d: "M55,0l102,0l0,427l76,0l0,80l-76,0l0,74C157,603 168,616 187,616l46,0l0,96l-47,0C120,712 55,674 55,576l0,-69l-50,0l0,-80l50,0M263,0l102,0l0,507l-102,0M263,610l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 5,
    horizAdvX: 372,
    d: "M338,712l-292,0l0,-384l90,0C142,340 153,367 188,367C216,367 236,344 236,316l0,-167C236,116 218,96 188,96C158,96 136,116 136,151l0,26l-102,0l0,-30C34,52 105,-6 186,-6C267,-6 338,52 338,147l0,184C338,413 290,457 221,457C185,457 155,442 136,424l0,192l202,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uFB02",
    horizAdvX: 407,
    d: "M55,0l102,0l0,427l76,0l0,80l-76,0l0,74C157,603 168,616 187,616l46,0l0,96l-47,0C120,712 55,674 55,576l0,-69l-50,0l0,-80l50,0M263,136C263,18 321,-6 415,-6l0,96C376,94 365,105 365,143l0,569l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0192",
    horizAdvX: 372,
    d: "M45,371l80,0l-75,-417C43,-83 26,-106 -9,-106C-22,-106 -37,-104 -49,-100l-11,-94C-43,-199 -30,-202 -7,-202C99,-202 133,-129 151,-27l71,398l78,0l13,80l-77,0l18,103C264,612 278,628 313,628C326,628 339,624 352,622l14,92C339,716 320,718 302,718C238,718 184,694 163,579l-23,-128l-84,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 4,
    horizAdvX: 372,
    d: "M212,0l102,0l0,106l49,0l0,96l-49,0l0,203l-102,0l0,-203l-101,0l153,510l-108,0l-147,-510l0,-96l203,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2044",
    horizAdvX: 167,
    d: "M-165,-17l60,0l437,746l-60,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "g",
    horizAdvX: 389,
    d: "M42,-59C55,-175 132,-211 194,-211C302,-211 347,-131 347,-62l0,569l-102,0l0,-46C219,490 199,513 149,513C100,513 75,494 58,467C45,446 42,417 42,344l0,-193C42,95 47,64 59,42C77,9 107,-6 148,-6C189,-6 221,13 243,46l2,0l0,-100C245,-86 231,-109 198,-109C163,-109 145,-83 144,-59M144,342C144,383 159,411 194,411C225,411 245,385 245,348l0,-197C245,119 223,96 194,96C155,96 144,124 144,156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xDF",
    horizAdvX: 389,
    d: "M42,0l102,0l0,534C144,600 159,622 197,622C236,622 245,601 245,573l0,-80C245,461 232,454 201,454l0,-90C229,364 245,357 245,331l0,-190C245,99 230,90 201,90l0,-96C276,-6 347,10 347,134l0,176C347,361 326,391 288,412C337,443 347,465 347,536C347,638 309,718 193,718C89,718 42,639 42,552z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "`",
    horizAdvX: 186,
    d: "M68,715l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ">",
    horizAdvX: 600,
    d: "M47,-8l506,231l0,60l-506,231l0,-80l397,-181l-397,-181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2265",
    horizAdvX: 401,
    d: "M44,561l0,-75l263,-150l0,-2l-263,-151l0,-75l319,194l0,66M365,10l0,64l-326,0l0,-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAB",
    horizAdvX: 426,
    d: "M398,479l-203,-202l203,-202l0,102l-101,100l101,100M213,479l-203,-202l203,-202l0,102l-101,100l101,100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBB",
    horizAdvX: 426,
    d: "M213,75l203,202l-203,202l0,-102l101,-100l-101,-100M28,75l203,202l-203,202l0,-102l101,-100l-101,-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2039",
    horizAdvX: 241,
    d: "M213,479l-203,-202l203,-202l0,102l-101,100l101,100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u203A",
    horizAdvX: 241,
    d: "M28,75l203,202l-203,202l0,-102l101,-100l-101,-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "h",
    horizAdvX: 389,
    d: "M42,0l102,0l0,341C144,386 157,411 195,411C227,411 245,388 245,351l0,-351l102,0l0,389C347,480 293,513 242,513C195,513 167,490 146,458l-2,0l0,254l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DD",
    horizAdvX: 186,
    d: "M-54,574l66,0l132,141l-108,0M108,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "-",
    horizAdvX: 389,
    d: "M44,226l301,0l0,102l-301,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "i",
    horizAdvX: 186,
    d: "M42,0l102,0l0,507l-102,0M42,610l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xED",
    horizAdvX: 186,
    d: "M42,0l102,0l0,507l-102,0M28,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEE",
    horizAdvX: 186,
    d: "M42,0l102,0l0,507l-102,0M-52,574l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEF",
    horizAdvX: 186,
    d: "M42,0l102,0l0,507l-102,0M-33,586l90,0l0,102l-90,0M129,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xEC",
    horizAdvX: 186,
    d: "M42,0l102,0l0,507l-102,0M68,715l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u221E",
    horizAdvX: 635,
    d: "M597,290C597,373 541,428 469,428C395,428 354,375 320,337C278,393 235,428 174,428C95,428 38,369 38,285C38,202 99,145 167,145C234,145 277,184 320,237C374,164 416,145 465,145C533,145 597,199 597,289M175,202C132,202 97,238 97,284C97,333 123,371 172,371C225,371 253,329 288,282C254,241 222,202 176,202M464,371C509,371 538,335 538,285C538,248 512,202 467,202C422,202 399,226 350,288C376,318 413,371 463,371z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u222B",
    horizAdvX: 327,
    d: "M296,853C286,858 269,862 250,862C214,862 176,845 155,817C122,773 109,712 109,595C109,426 119,275 119,95C119,5 113,-41 102,-63C94,-78 82,-84 70,-84C57,-84 48,-79 42,-76l-14,-80C38,-162 58,-169 83,-169C123,-169 165,-152 186,-105C206,-64 215,0 215,99C215,276 205,425 205,587C205,676 209,731 225,757C235,775 247,783 261,783C272,783 278,780 285,776z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "j",
    horizAdvX: 186,
    d: "M42,-16C42,-90 27,-109 -22,-109l0,-96C74,-205 144,-154 144,-54l0,561l-102,0M42,610l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "k",
    horizAdvX: 389,
    d: "M42,0l102,0l0,142l49,77l92,-219l111,0l-146,301l121,206l-102,0l-123,-221l-2,0l0,426l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "l",
    horizAdvX: 186,
    d: "M36,136C36,18 94,-6 188,-6l0,96C149,94 138,105 138,143l0,569l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "<",
    horizAdvX: 600,
    d: "M553,514l-506,-231l0,-60l506,-231l0,80l-397,181l397,181z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2264",
    horizAdvX: 401,
    d: "M360,108l0,75l-264,151l0,2l264,150l0,75l-319,-193l0,-67M365,10l0,64l-327,0l0,-64z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAC",
    horizAdvX: 600,
    d: "M473,113l80,0l0,280l-506,0l0,-80l426,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u25CA",
    horizAdvX: 438,
    d: "M399,349l-134,388l-83,0l-142,-388l134,-387l83,0M310,347l-77,-227C229,108 222,72 220,56l-5,0C213,71 209,99 202,122l-73,230l76,219C212,596 216,621 220,642l3,0C226,622 231,594 238,571z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0142",
    horizAdvX: 186,
    d: "M36,136C36,18 94,-6 188,-6l0,96C149,94 138,105 138,143l0,255l50,43l0,72l-50,-43l0,242l-102,0l0,-332l-50,-44l0,-72l50,44z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "m",
    horizAdvX: 592,
    d: "M42,0l102,0l0,341C144,386 157,411 195,411C227,411 245,388 245,351l0,-351l102,0l0,341C347,386 360,411 398,411C430,411 448,388 448,351l0,-351l102,0l0,389C550,480 490,513 439,513C385,513 358,490 333,462C315,487 286,513 242,513C195,513 167,490 146,458l-2,0l0,49l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAF",
    horizAdvX: 186,
    d: "M-44,607l274,0l0,60l-274,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2212",
    horizAdvX: 600,
    d: "M47,213l506,0l0,80l-506,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB5",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-712l102,0l0,209l2,0C152,-2 162,-6 177,-6C188,-6 199,-2 211,7C222,16 234,30 243,49l2,0l0,-49l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xD7",
    horizAdvX: 600,
    d: "M67,77l57,-57l176,177l177,-177l56,57l-176,176l176,177l-56,56l-177,-176l-176,176l-57,-56l177,-177z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "n",
    horizAdvX: 389,
    d: "M42,0l102,0l0,341C144,386 157,411 195,411C227,411 245,388 245,351l0,-351l102,0l0,389C347,480 293,513 242,513C195,513 167,490 146,458l-2,0l0,49l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 9,
    horizAdvX: 372,
    d: "M71,0l114,0l134,358C333,396 338,416 338,504C338,597 334,617 314,649C287,692 241,718 186,718C130,718 83,693 57,649C38,617 34,597 34,504C34,391 38,366 56,338C73,312 106,292 142,292C164,292 178,296 185,301l2,-2M136,565C136,596 160,616 186,616C212,616 236,596 236,565l0,-132C236,402 212,382 186,382C160,382 136,402 136,433z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE000",
    horizAdvX: 372,
    d: "M34,360C34,319 38,294 56,266C73,240 106,220 142,220C176,220 204,228 236,243l0,-96C236,118 215,96 186,96C157,96 136,118 136,147l-102,0C34,52 105,-6 186,-6C267,-6 338,52 338,147l0,418C338,660 267,718 186,718C105,718 34,660 34,565M136,565C136,596 160,616 186,616C212,616 236,596 236,565l0,-204C236,330 212,310 186,310C160,310 136,330 136,361z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2260",
    horizAdvX: 401,
    d: "M296,471l-46,16l-34,-87l-179,0l0,-62l159,0l-43,-111l-116,0l0,-61l96,0l-28,-71l46,-15l34,86l178,0l0,61l-158,0l44,111l114,0l0,62l-95,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF1",
    horizAdvX: 389,
    d: "M42,0l102,0l0,341C144,386 157,411 195,411C227,411 245,388 245,351l0,-351l102,0l0,389C347,480 293,513 242,513C195,513 167,490 146,458l-2,0l0,49l-102,0M314,699C313,673 298,654 270,654C248,654 157,694 126,694C62,694 37,644 25,583l51,0C77,609 92,628 120,628C143,628 233,588 264,588C328,588 353,638 365,699z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "#",
    horizAdvX: 372,
    d: "M180,0l68,0l29,215l58,0l0,60l-50,0l22,162l59,0l0,60l-51,0l29,215l-68,0l-29,-215l-84,0l29,215l-68,0l-29,-215l-58,0l0,-60l50,0l-22,-162l-59,0l0,-60l51,0l-29,-215l68,0l29,215l84,0M217,275l-84,0l22,162l84,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "o",
    horizAdvX: 370,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,167C337,378 332,414 318,440C294,484 247,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF3",
    horizAdvX: 370,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,167C337,378 332,414 318,440C294,484 247,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154M120,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF4",
    horizAdvX: 370,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,167C337,378 332,414 318,440C294,484 247,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154M40,574l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF6",
    horizAdvX: 370,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,167C337,378 332,414 318,440C294,484 247,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154M59,586l90,0l0,102l-90,0M221,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0153",
    horizAdvX: 572,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C224,-6 260,8 282,29C305,5 350,-6 387,-6C434,-6 471,11 498,39C524,66 539,105 539,147l-102,0C435,125 426,96 387,96C356,96 337,114 337,146l0,69l202,0l0,140C539,444 481,513 387,513C349,513 312,502 286,479C263,498 227,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M337,353C337,391 356,411 387,411C418,411 437,391 437,353l0,-58l-100,0M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DB",
    horizAdvX: 186,
    d: "M181,-165C167,-173 150,-178 128,-178C102,-178 79,-158 79,-126C79,-85 103,-38 143,0l-51,0C40,-36 -1,-68 -1,-133C-1,-189 42,-224 98,-224C142,-224 175,-213 195,-202z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF2",
    horizAdvX: 370,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,167C337,378 332,414 318,440C294,484 247,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154M160,715l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 1,
    horizAdvX: 372,
    d: "M155,0l102,0l0,712l-102,0l-102,-75l0,-108l102,75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBD",
    horizAdvX: 555,
    d: "M18,-17l60,0l437,746l-60,0M77,287l80,0l0,425l-80,0l-66,-43l0,-72l66,43M322,0l222,0l0,72l-118,0l95,160C535,255 544,272 544,307l0,33C544,393 494,431 434,431C370,431 322,389 322,333l0,-36l80,0l0,31C402,348 416,359 433,359C447,359 464,348 464,328l0,-23C464,291 459,278 452,266l-130,-212z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBC",
    horizAdvX: 555,
    d: "M18,-17l60,0l437,746l-60,0M77,287l80,0l0,425l-80,0l-66,-43l0,-72l66,43M434,0l80,0l0,62l30,0l0,66l-30,0l0,115l-80,0l0,-115l-59,0l94,299l-80,0l-98,-303l0,-62l143,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB9",
    horizAdvX: 242,
    d: "M93,287l80,0l0,425l-80,0l-66,-43l0,-72l66,43z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAA",
    horizAdvX: 240,
    d: "M154,410l72,0l0,212C226,685 176,718 121,718C91,718 66,708 48,692C31,676 20,653 18,622l66,0C87,644 104,652 121,652C145,652 154,636 154,616l0,-24C140,593 131,594 122,594C39,594 14,558 14,488C14,420 58,406 89,406C121,406 135,419 152,441l2,0M154,504C154,485 140,470 118,470C97,470 86,481 86,499C86,532 107,543 136,543C141,543 147,542 154,541z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBA",
    horizAdvX: 240,
    d: "M18,505C18,448 58,406 120,406C182,406 222,448 222,505l0,114C222,676 182,718 120,718C58,718 18,676 18,619M90,617C90,640 101,652 120,652C139,652 150,640 150,617l0,-111C150,484 139,472 120,472C101,472 90,484 90,506z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF8",
    horizAdvX: 370,
    d: "M137,209l-2,0l0,144C135,391 154,411 185,411C211,411 228,397 232,372M233,298l2,0l0,-144C235,116 216,96 185,96C159,96 142,110 138,135M4,-12l34,-21l41,69C105,9 141,-6 185,-6C279,-6 337,63 337,158l0,191C337,381 330,410 317,436l49,83l-34,21l-41,-69C265,498 229,513 185,513C91,513 33,444 33,349l0,-191C33,126 40,97 53,71z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF5",
    horizAdvX: 370,
    d: "M33,170C33,129 38,93 52,67C76,23 123,-6 185,-6C247,-6 294,23 318,67C332,93 337,129 337,170l0,167C337,378 332,414 318,440C294,484 247,513 185,513C123,513 76,484 52,440C38,414 33,378 33,337M135,353C135,391 154,411 185,411C216,411 235,391 235,353l0,-199C235,116 216,96 185,96C154,96 135,116 135,154M304,699C303,673 288,654 260,654C238,654 147,694 116,694C52,694 27,644 15,583l51,0C67,609 82,628 110,628C133,628 223,588 254,588C318,588 343,638 355,699z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "p",
    horizAdvX: 389,
    d: "M42,-205l102,0l0,251l2,0C168,13 200,-6 240,-6C289,-6 314,13 331,40C344,61 347,90 347,163l0,193C347,412 342,443 330,465C312,498 282,513 241,513C190,513 170,490 144,461l0,46l-102,0M245,156C245,124 234,96 195,96C166,96 144,119 144,151l0,197C144,385 164,411 195,411C230,411 245,383 245,342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB6",
    horizAdvX: 444,
    d: "M182,-205l72,0l0,866l72,0l0,-866l72,0l0,917l-172,0C96,712 8,650 8,520C8,416 95,334 182,334z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "(",
    horizAdvX: 222,
    d: "M169,712C95,601 50,443 50,306C50,177 89,16 169,-100l34,0C171,16 152,143 152,278C152,424 164,575 203,712z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ")",
    horizAdvX: 222,
    d: "M53,-100C127,11 172,169 172,306C172,435 133,596 53,712l-34,0C51,596 70,469 70,334C70,188 58,37 19,-100z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2202",
    horizAdvX: 410,
    d: "M79,659C100,683 128,706 166,706C235,706 278,590 278,471l0,-29l-1,0C265,466 236,496 190,496C110,496 32,399 32,229C32,104 84,0 175,0C301,0 372,143 372,424C372,696 274,797 179,797C117,797 79,769 54,746M184,93C148,93 128,144 128,222C128,316 158,407 206,407C242,407 264,372 272,341C266,219 236,93 186,93z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "%",
    horizAdvX: 352,
    d: "M94,555C81,555 69,567 69,581l0,51C69,646 81,658 94,658C107,658 119,646 119,632l0,-51C119,567 107,555 94,555M94,495C146,495 179,526 179,571l0,65C179,686 146,718 94,718C42,718 9,686 9,636l0,-65C9,526 42,495 94,495M233,131C233,145 245,157 258,157C271,157 283,145 283,131l0,-51C283,66 271,54 258,54C245,54 233,66 233,80M258,-6C310,-6 343,25 343,70l0,65C343,185 310,217 258,217C206,217 173,185 173,135l0,-65C173,25 206,-6 258,-6M21,0l66,0l244,712l-66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ".",
    horizAdvX: 186,
    d: "M42,0l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB7",
    horizAdvX: 186,
    d: "M29,298C29,263 58,234 93,234C128,234 157,263 157,298C157,333 128,362 93,362C58,362 29,333 29,298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2030",
    horizAdvX: 537,
    d: "M418,131C418,145 430,157 443,157C456,157 468,145 468,131l0,-51C468,66 456,54 443,54C430,54 418,66 418,80M358,70C358,25 391,-6 443,-6C495,-6 528,25 528,70l0,65C528,185 495,217 443,217C391,217 358,185 358,135M69,632C69,646 81,658 94,658C107,658 119,646 119,632l0,-51C119,567 107,555 94,555C81,555 69,567 69,581M9,571C9,526 42,495 94,495C146,495 179,526 179,571l0,65C179,686 146,718 94,718C42,718 9,686 9,636M225,131C225,145 237,157 250,157C263,157 275,145 275,131l0,-51C275,66 263,54 250,54C237,54 225,66 225,80M165,70C165,25 198,-6 250,-6C302,-6 335,25 335,70l0,65C335,185 302,217 250,217C198,217 165,185 165,135M20,0l66,0l244,712l-66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u03C0",
    horizAdvX: 422,
    d: "M403,430l6,95l-285,0C65,525 25,511 7,495l12,-72C31,427 47,430 80,430C79,318 62,126 36,0l91,0C155,121 170,325 174,430l88,0l0,-301C262,66 266,22 275,0l91,0C360,28 357,64 357,128l0,302z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "+",
    horizAdvX: 600,
    d: "M260,293l-213,0l0,-80l213,0l0,-213l80,0l0,213l213,0l0,80l-213,0l0,213l-80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB1",
    horizAdvX: 600,
    d: "M260,104l80,0l0,161l213,0l0,80l-213,0l0,161l-80,0l0,-161l-213,0l0,-80l213,0M47,0l506,0l0,80l-506,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u220F",
    horizAdvX: 513,
    d: "M489,599l0,100l-466,0l0,-100l64,0l0,-696l97,0l0,696l144,0l0,-696l97,0l0,696z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "q",
    horizAdvX: 389,
    d: "M245,-205l102,0l0,712l-102,0l0,-46C219,490 199,513 148,513C107,513 77,498 59,465C47,443 42,412 42,356l0,-193C42,90 45,61 58,40C75,13 100,-6 149,-6C189,-6 221,13 243,46l2,0M144,342C144,383 159,411 194,411C225,411 245,385 245,348l0,-197C245,119 223,96 194,96C155,96 144,124 144,156z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "?",
    horizAdvX: 370,
    d: "M32,507l102,0l0,58C134,598 162,616 186,616C214,616 236,593 236,565l0,-53C236,492 233,471 223,454l-64,-104C144,325 134,298 134,269l0,-93l102,0l0,80C236,274 244,291 253,307l69,118C335,447 338,471 338,539C338,600 331,625 304,661C277,697 235,718 186,718C101,718 32,650 32,566M134,0l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBF",
    horizAdvX: 370,
    d: "M338,0l-102,0l0,-58C236,-91 208,-109 184,-109C156,-109 134,-86 134,-58l0,53C134,15 137,36 147,53l64,104C226,182 236,209 236,238l0,93l-102,0l0,-80C134,233 126,216 117,200l-69,-118C35,60 32,36 32,-32C32,-93 39,-118 66,-154C93,-190 135,-211 184,-211C269,-211 338,-143 338,-59M236,507l-102,0l0,-102l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\"",
    horizAdvX: 278,
    d: "M33,536l80,0l0,176l-80,0M165,536l80,0l0,176l-80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201E",
    horizAdvX: 278,
    d: "M18,-74l102,74l0,102l-102,0M158,-74l102,74l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201C",
    horizAdvX: 278,
    d: "M260,712l-102,-74l0,-102l102,0M120,712l-102,-74l0,-102l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201D",
    horizAdvX: 278,
    d: "M18,536l102,74l0,102l-102,0M158,536l102,74l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2018",
    horizAdvX: 186,
    d: "M144,712l-102,-74l0,-102l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2019",
    horizAdvX: 186,
    d: "M42,536l102,74l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u201A",
    horizAdvX: 186,
    d: "M42,-74l102,74l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "'",
    horizAdvX: 186,
    d: "M53,536l80,0l0,176l-80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "r",
    horizAdvX: 278,
    d: "M42,0l102,0l0,301C144,384 205,411 248,411C259,411 269,409 279,405l0,108C220,513 186,490 144,453l0,54l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u221A",
    horizAdvX: 439,
    d: "M433,842l-65,0l-119,-734C243,69 240,27 238,7l-1,1C235,28 228,68 222,105l-64,294l-131,-51l15,-63l54,21l103,-443l78,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAE",
    horizAdvX: 800,
    d: "M329,507l96,0C470,507 502,490 502,451C502,406 469,388 404,388l-75,0M263,145l66,0l0,183l51,0l121,-183l80,0l-121,185C519,337 568,369 568,448C568,528 520,567 423,567l-160,0M690,356C690,193 560,60 400,60C240,60 110,193 110,356C110,519 240,652 400,652C560,652 690,519 690,356M38,356C38,156 200,-6 400,-6C600,-6 762,156 762,356C762,556 600,718 400,718C200,718 38,556 38,356z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DA",
    horizAdvX: 186,
    d: "M-9,660C-9,605 37,558 93,558C149,558 195,604 195,660C195,715 149,762 93,762C37,762 -9,716 -9,660M32,660C32,694 59,721 93,721C127,721 154,694 154,660C154,626 127,599 93,599C59,599 32,626 32,660z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "s",
    horizAdvX: 352,
    d: "M323,365C322,449 262,513 179,513C97,513 29,451 29,365C29,297 68,249 132,225l49,-18C220,192 232,173 232,145C232,111 204,90 175,90C137,90 124,119 120,147l-96,0C28,47 96,-6 176,-6C264,-6 328,63 328,147C328,207 304,261 228,290l-60,24C130,329 125,347 125,366C125,392 143,417 175,417C202,417 226,399 227,365z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u0161",
    horizAdvX: 352,
    d: "M323,365C322,449 262,513 179,513C97,513 29,451 29,365C29,297 68,249 132,225l49,-18C220,192 232,173 232,145C232,111 204,90 175,90C137,90 124,119 120,147l-96,0C28,47 96,-6 176,-6C264,-6 328,63 328,147C328,207 304,261 228,290l-60,24C130,329 125,347 125,366C125,392 143,417 175,417C202,417 226,399 227,365M321,715l-78,0l-67,-95l-67,95l-78,0l98,-141l94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA7",
    horizAdvX: 370,
    d: "M325,581C325,673 256,718 190,718C116,718 53,669 53,564C53,494 59,463 125,430C51,407 33,374 33,259C33,166 37,129 90,97l118,-72C234,9 240,-3 240,-53C240,-106 224,-131 183,-131C151,-131 128,-102 128,-67l0,41l-85,0l0,-42C43,-126 77,-211 186,-211C231,-211 277,-190 300,-157C320,-128 325,-99 325,-43C325,38 317,64 250,98C331,135 337,162 337,259C337,363 330,387 282,418l-97,63C141,509 138,517 138,565C138,605 148,638 190,638C223,638 240,608 240,577l0,-42l85,0M135,312C135,341 157,365 185,365C212,365 235,341 235,312l0,-99C235,184 212,160 185,160C157,160 135,184 135,213z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: ";",
    horizAdvX: 186,
    d: "M42,-74l102,74l0,102l-102,0M42,227l102,0l0,102l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 7,
    horizAdvX: 372,
    d: "M57,0l108,0l173,610l0,102l-304,0l0,-178l90,0l0,82l112,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 6,
    horizAdvX: 372,
    d: "M301,712l-114,0l-134,-358C39,316 34,296 34,208C34,115 38,95 58,63C85,20 131,-6 186,-6C242,-6 289,19 315,63C334,95 338,115 338,208C338,321 334,346 316,374C299,400 266,420 230,420C208,420 194,416 187,411l-2,2M236,147C236,116 212,96 186,96C160,96 136,116 136,147l0,132C136,310 160,330 186,330C212,330 236,310 236,279z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\uE001",
    horizAdvX: 372,
    d: "M34,147C34,52 105,-6 186,-6C267,-6 338,52 338,147l0,205C338,393 334,418 316,446C299,472 266,492 230,492C196,492 168,484 136,469l0,96C136,594 157,616 186,616C215,616 236,594 236,565l102,0C338,660 267,718 186,718C105,718 34,660 34,565M136,351C136,382 160,402 186,402C212,402 236,382 236,351l0,-204C236,116 212,96 186,96C160,96 136,116 136,147z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "/",
    horizAdvX: 222,
    d: "M5,-6l80,0l132,724l-80,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: " ",
    horizAdvX: 186
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA3",
    horizAdvX: 372,
    d: "M13,298l78,0C105,262 114,219 114,190C114,159 104,128 87,103C65,101 33,89 23,83l0,-86C36,3 73,13 102,13C147,13 234,-6 272,-6C319,-6 352,10 383,53l-68,69C291,93 272,90 249,90C221,90 189,98 167,101C186,134 199,170 199,210C199,252 190,273 181,298l93,0l0,71l-116,0C142,411 126,468 126,520C126,576 142,622 189,622C232,622 244,586 244,550l0,-40l96,0l0,45C340,669 258,718 192,718C77,718 30,626 30,521C30,453 43,416 68,369l-55,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2211",
    horizAdvX: 391,
    d: "M376,-97l0,103l-249,0l0,3l170,318l-149,281l0,3l215,0l0,88l-338,0l0,-77l166,-318l-170,-326l0,-75z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "t",
    horizAdvX: 204,
    d: "M42,507l-51,0l0,-80l51,0l0,-308C42,65 73,0 165,0l42,0l0,96C162,96 144,99 144,146l0,281l63,0l0,80l-63,0l0,154l-102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFE",
    horizAdvX: 389,
    d: "M42,-205l102,0l0,251l2,0C168,13 200,-6 240,-6C289,-6 314,13 331,40C344,61 347,90 347,163l0,193C347,412 342,443 330,465C312,498 282,513 241,513C190,513 170,490 144,461l0,251l-102,0M245,156C245,124 234,96 195,96C166,96 144,119 144,151l0,197C144,385 164,411 195,411C230,411 245,383 245,342z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 3,
    horizAdvX: 372,
    d: "M155,322C221,322 236,310 236,255l0,-102C236,118 217,96 186,96C155,96 136,119 136,151l0,53l-102,0l0,-58C34,34 120,-6 185,-6C247,-6 286,22 311,59C332,90 338,111 338,205C338,306 338,329 275,368C333,403 338,419 338,517C338,608 326,636 299,668C281,690 243,718 188,718C104,718 34,651 34,567l0,-59l102,0l0,58C136,587 150,616 186,616C217,616 236,595 236,566l0,-92C236,421 216,412 155,412z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xBE",
    horizAdvX: 555,
    d: "M37,-17l60,0l437,746l-60,0M100,474C141,474 151,467 151,437l0,-52C151,370 138,355 121,355C103,355 91,368 91,388l0,23l-80,0l0,-34C11,307 67,283 121,283C199,283 231,335 231,384l0,51C231,468 222,489 190,508C226,527 231,548 231,577l0,41C231,667 197,718 123,718C57,718 11,678 11,622l0,-32l80,0l0,26C91,628 100,646 121,646C139,646 151,633 151,616l0,-42C150,546 139,540 100,540M434,0l80,0l0,62l30,0l0,66l-30,0l0,115l-80,0l0,-115l-59,0l94,299l-80,0l-98,-303l0,-62l143,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB3",
    horizAdvX: 242,
    d: "M100,474C141,474 151,467 151,437l0,-52C151,370 138,355 121,355C103,355 91,368 91,388l0,23l-80,0l0,-34C11,307 67,283 121,283C199,283 231,335 231,384l0,51C231,468 222,489 190,508C226,527 231,548 231,577l0,41C231,667 197,718 123,718C57,718 11,678 11,622l0,-32l80,0l0,26C91,628 100,646 121,646C139,646 151,633 151,616l0,-42C150,546 139,540 100,540z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02DC",
    horizAdvX: 186,
    d: "M212,699C211,673 196,654 168,654C146,654 55,694 24,694C-40,694 -65,644 -77,583l51,0C-25,609 -10,628 18,628C41,628 131,588 162,588C226,588 251,638 263,699z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2122",
    horizAdvX: 990,
    d: "M166,300l72,0l0,346l127,0l0,66l-326,0l0,-66l127,0M805,300l72,0l0,412l-114,0l-117,-301l-117,301l-114,0l0,-412l72,0l0,346l2,0l136,-346l41,0l137,346l2,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 2,
    horizAdvX: 372,
    d: "M34,0l304,0l0,102l-184,0l150,289C336,452 338,470 338,539C338,634 293,718 187,718C102,718 34,648 34,563l0,-56l102,0l0,58C136,598 156,616 186,616C236,616 236,573 236,537C236,498 236,478 218,443l-184,-347z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xB2",
    horizAdvX: 242,
    d: "M11,584l80,0l0,31C91,635 105,646 120,646C134,646 151,635 151,615l0,-23C151,578 146,565 139,553l-128,-212l0,-54l220,0l0,72l-118,0l95,160C222,542 231,559 231,594l0,33C231,680 181,718 121,718C59,718 11,676 11,620z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "u",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-389C42,27 96,-6 147,-6C194,-6 222,17 243,49l2,0l0,-49l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFA",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-389C42,27 96,-6 147,-6C194,-6 222,17 243,49l2,0l0,-49l102,0M130,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFB",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-389C42,27 96,-6 147,-6C194,-6 222,17 243,49l2,0l0,-49l102,0M50,574l78,0l67,95l67,-95l78,0l-98,141l-94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFC",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-389C42,27 96,-6 147,-6C194,-6 222,17 243,49l2,0l0,-49l102,0M69,586l90,0l0,102l-90,0M231,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xF9",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-389C42,27 96,-6 147,-6C194,-6 222,17 243,49l2,0l0,-49l102,0M170,715l-108,0l132,-141l66,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "_",
    horizAdvX: 500,
    d: "M0,-125l500,0l0,50l-500,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA0",
    horizAdvX: 186
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xAD",
    horizAdvX: 389,
    d: "M44,226l301,0l0,102l-301,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u02C9",
    horizAdvX: 186,
    d: "M-44,607l274,0l0,60l-274,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u03A9",
    horizAdvX: 455,
    d: "M110,89l-88,0l0,-89l172,0l0,63C163,105 130,223 130,368C130,512 164,614 228,614C296,614 321,494 321,371C321,214 290,106 257,63l0,-63l172,0l0,89l-88,0l0,3C380,155 419,271 419,399C419,547 361,709 231,709C111,709 33,572 33,389C33,265 69,160 110,92z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u03BC",
    horizAdvX: 389,
    d: "M347,507l-102,0l0,-341C245,121 232,96 194,96C162,96 144,119 144,156l0,351l-102,0l0,-712l102,0l0,209l2,0C152,-2 162,-6 177,-6C188,-6 199,-2 211,7C222,16 234,30 243,49l2,0l0,-49l102,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2010",
    horizAdvX: 389,
    d: "M44,226l301,0l0,102l-301,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2215",
    horizAdvX: 167,
    d: "M-165,-17l60,0l437,746l-60,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u2219",
    horizAdvX: 186,
    d: "M29,298C29,263 58,234 93,234C128,234 157,263 157,298C157,333 128,362 93,362C58,362 29,333 29,298z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "v",
    horizAdvX: 352,
    d: "M353,507l-108,0l-68,-324l-2,0l-68,324l-108,0l132,-507l90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "w",
    horizAdvX: 536,
    d: "M535,507l-108,0l-61,-315l-2,0l-54,315l-80,0l-57,-315l-2,0l-62,315l-108,0l120,-507l90,0l56,301l2,0l56,-301l90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "x",
    horizAdvX: 332,
    d: "M-11,0l108,0l69,155l69,-155l108,0l-127,259l121,248l-108,0l-63,-144l-63,144l-108,0l119,-248z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "y",
    horizAdvX: 352,
    d: "M-1,507l139,-484C115,-95 102,-109 61,-109l-23,0l0,-96l28,0C127,-205 185,-179 207,-88l146,595l-105,0l-69,-316l-2,0l-70,316z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFD",
    horizAdvX: 352,
    d: "M-1,507l139,-484C115,-95 102,-109 61,-109l-23,0l0,-96l28,0C127,-205 185,-179 207,-88l146,595l-105,0l-69,-316l-2,0l-70,316M111,574l66,0l132,141l-108,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xFF",
    horizAdvX: 352,
    d: "M-1,507l139,-484C115,-95 102,-109 61,-109l-23,0l0,-96l28,0C127,-205 185,-179 207,-88l146,595l-105,0l-69,-316l-2,0l-70,316M50,586l90,0l0,102l-90,0M212,586l90,0l0,102l-90,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\xA5",
    horizAdvX: 372,
    d: "M138,0l96,0l0,172l114,0l0,66l-114,0l0,49l114,0l0,66l-98,0l118,359l-102,0l-79,-283l-2,0l-79,283l-102,0l118,-359l-98,0l0,-66l114,0l0,-49l-114,0l0,-66l114,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "z",
    horizAdvX: 315,
    d: "M17,0l281,0l0,96l-165,0l165,330l0,81l-268,0l0,-90l152,0l-165,-336z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: "\u017E",
    horizAdvX: 315,
    d: "M17,0l281,0l0,96l-165,0l165,330l0,81l-268,0l0,-90l152,0l-165,-336M303,715l-78,0l-67,-95l-67,95l-78,0l98,-141l94,0z"
  }), /*#__PURE__*/React.createElement("glyph", {
    unicode: 0,
    horizAdvX: 372,
    d: "M34,147C34,52 105,-6 186,-6C267,-6 338,52 338,147l0,418C338,660 267,718 186,718C105,718 34,660 34,565M136,565C136,594 157,616 186,616C215,616 236,594 236,565l0,-418C236,118 215,96 186,96C157,96 136,118 136,147z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 48,
    cy: 48,
    r: 46
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B33229"
    },
    d: "M48,14c18.778,0,34,15.222,34,34S66.778,82,48,82S14,66.778,14,48S29.222,14,48,14 M48,4 C23.738,4,4,23.738,4,48s19.738,44,44,44s44-19.738,44-44S72.262,4,48,4L48,4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.044,
    y: 29,
    style: {
      fill: "none"
    },
    width: 73.913,
    height: 41
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 17.8687 67.4473)",
    style: {
      display: "none",
      fontFamily: "'DINEngschriftStd'",
      fontSize: 54
    }
  }, "120")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrafficSignSpeedLimitEu);
export default __webpack_public_path__ + "static/media/icon-traffic_sign_speed_limit_eu.a4c5c7027035521d04b990d1acb5c63a.svg";
export { ForwardRef as ReactComponent };